export const isBoardMember = (array, board) => {
  try {
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const isManagerRole = (array, board, role) => {
  try {
    if (role === "admin") {
      return true;
    }
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return array[index].managerRole;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const isManagerRoleBoth = (array, board, role, managerOf) => {
  try {
    if (role === "admin") {
      return true;
    }
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return array[index].managerRole;
    } else {
      const managerIndex = managerOf.findIndex((e) => e.toString() === board);
      if (managerIndex >= 0) {
        return true;
      } else {
        return false;
      }
    }
  } catch (error) {
    return false;
  }
};

export const isAdminRole = (array, board) => {
  try {
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return array[index].adminRole;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const isBoardManager = (array, board) => {
  try {
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return array[index].managerRole;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const isVoterOnly = (array, board, role) => {
  try {
    if (role === "admin") {
      return false;
    }
    const index = array.findIndex((e) => e.boardId === board);
    if (array[index].managerRole === false) {
      if (array[index].votingRole) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

// export const isManagerOrAdmin = (array, board, role, managerOf) => {
//   try {
//     if (role === "admin") {
//       return true;
//     }
//     const index = array.findIndex((e) => e.boardId === board);
//     if (index >= 0) {
//       if (array[index].adminRole) {
//         return true;
//       } else if (array[index].managerRole) {
//         return true;
//       } else {
//         return false;
//       }
//     } else {
//       if (managerOf) {
//         const managerIndex = managerOf.findIndex((e) => e.toString() === board);
//         if (managerIndex >= 0) {
//           return true;
//         } else {
//           return false;
//         }
//       } else {
//         return false;
//       }
//     }
//   } catch (error) {
//     return false;
//   }
// };

export const isManagerOrAdmin = (array, board, role, managerOf = null) => {
  try {
    if (role === "admin") return true;

    // Check memberOf
    const boardMember = array?.find((e) => e.boardId === board);
    if (boardMember?.adminRole || boardMember?.managerRole) return true;

    // Check managerOf (only if provided)
    if (managerOf?.some((e) => e.toString() === board.toString())) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};

export const getBoardRoles = (array, board) => {
  try {
    const index = array.findIndex((e) => e.boardId === board);
    if (index >= 0) {
      return array[index];
    } else {
      return null;
    }
  } catch (error) {
    return false;
  }
};

export function shouldBlurTopic({ platform, crud, user, item }) {
  if (platform?.isolateTopics && !crud.admin) {
    if (crud.bypassVisibility) {
      return false;
    }
    if (item.teamAssigned) {
      const exists = user?.teams?.some(
        (team) => team.id?.toString() === item.teamAssigned?.toString(),
      );
      return !exists;
    }
  }
  return false;
}

export const legislaideCityCodes = {
  wvwd: "WestValleyWaterDistrictCA",
  sierramadreca: "sierra_madre_city:CA",
  // "0001": "sierra_madre_city:CA",
};
